// @flow
import { CommonMapper } from 'mappers/common';
import { ProductActionTypes } from './actionTypes';
import { ProductMapper } from 'mappers/product';

const getGalleryForProduct = (product_url_slug: string) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: ProductActionTypes.GALLERY.FETCH,
    payload: {},
    test: api
      .post(`galleries.json`, {
        url_slug: product_url_slug,
        model: 'product',
      })
      .then(res => {
        const response = res.data.data || {};
        const galleryImages = response.galleries || [];
        const mediaPath = CommonMapper.extractMediaPath(response);

        dispatch({
          type: ProductActionTypes.GALLERY.SUCCESS,
          payload: CommonMapper.mapGalleryImages(galleryImages, mediaPath),
        });

        return res.data;
      })
      .catch(error => {
        dispatch({
          type: ProductActionTypes.GALLERY.FAILURE,
          error,
        });
      }),
  });
};

const getVersionsForProduct = (product_url_slug: string) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: ProductActionTypes.VERSIONS.FETCH,
    payload: {},
    test: api
      .post(`floorPlans.json`, {
        product_url_slug: product_url_slug,
      })
      .then(res => {
        const response = res.data.result.data || {};
        const floorPlans = response.floor_plans || [];
        const mediaPath = CommonMapper.extractMediaPath(response);

        dispatch({
          type: ProductActionTypes.VERSIONS.SUCCESS,
          payload: ProductMapper.mapVersions(floorPlans, mediaPath),
        });

        return res.data;
      })
      .catch(error => {
        dispatch({
          type: ProductActionTypes.VERSIONS.FAILURE,
          error,
        });
      }),
  });
};

export const ProductActions = {
  getGalleryForProduct,
  getVersionsForProduct,
};
